export default function insertIfExists(elements) {
    return elements ? [...elements] : [];
}
